import styled from "styled-components";
import { apolloZindexTooltip, apolloSpaceInsetHalfX, apolloSpaceInset1X } from "@nexthink/apollo-tokens";
import { StyledText } from "../text/Text";
export const StyledContextActionMenu = styled.div.withConfig({ displayName: "StyledContextActionMenu_APC-7311-productShell", componentId: "sc-neosr6" })(({ theme }) => ({
    borderRadius: 4,
    boxShadow: theme.colors.apolloBoxShadowTooltip,
    overflow: "hidden",
    zIndex: apolloZindexTooltip,
}));
export const StyledContextTarget = styled.div.withConfig({ displayName: "StyledContextTarget_APC-7311-productShell", componentId: "sc-15s2eah" })({
    display: "contents",
});
export const StyledContextMenuErrorMessage = styled(StyledContextActionMenu).withConfig({ displayName: "StyledContextMenuErrorMessage_APC-7311-productShell", componentId: "sc-e8eweu" })(({ theme }) => ({
    background: theme.colors.apolloColorBackgroundPopover,
    padding: `${apolloSpaceInsetHalfX} ${apolloSpaceInset1X} ${apolloSpaceInset1X} ${apolloSpaceInset1X}`,
    [`& ${StyledText}`]: {
        color: theme.colors.apolloColorTextPopoverPrimary,
    },
}));
//# sourceMappingURL=ContextActionMenu.style.js.map